import { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { cn } from "@/lib/utils";
// @ts-ignore - idk why this is throwing an error
import image1 from "../../assets/1.png";
// @ts-ignore - idk why this is throwing an error
import image2 from "../../assets/2.png";
// @ts-ignore - idk why this is throwing an error
import image3 from "../../assets/3.png";
// @ts-ignore - idk why this is throwing an error
import image4 from "../../assets/4.png";
// @ts-ignore - idk why this is throwing an error
import image5 from "../../assets/5.png";

export const ImageCarousel = ({ className }: { className: string }) => {
  const images = [image1, image2, image5, image3, image4];
  const [currentImage, setCurrentImage] = useState(0);
  const scrollRef = useRef(null);
  const { scrollYProgress } = useScroll();
  const scale = useTransform(scrollYProgress, [0, 1], [1, 3]); // Scale from 1 to 3 (300%)
  const opacity = useTransform(scrollYProgress, [0.8, 1], [1, 0]); // Opacity from 1 (100%) to 0 (0%)
  const [hide, setHide] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 300);
    return () => clearInterval(interval);
  }, [images.length]);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollYProgress.get() >= 0.99) {
        setHide(true);
      } else {
        setHide(false);
      }
    };

    const unsubscribe = scrollYProgress.onChange(handleScroll);

    return () => {
      unsubscribe();
    };
  }, [scrollYProgress]);

  if (hide) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        zIndex: 0,
      }}
    >
      <motion.div
        viewport={{ root: scrollRef }}
        style={{
          scale: scale,
          opacity: opacity,
          transformOrigin: "center",
          width: "100%",
          height: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          pointerEvents: "none", // Disable pointer events when opacity is 0
        }}
      >
        <img
          className={cn(className, "w-full z-50")}
          src={images[currentImage]}
          alt={"my img"}
        />
      </motion.div>
    </div>
  );
};
